import {Injectable} from '@angular/core';
import {ConnectionBackend, Headers, Http, Request, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {environment} from "../../../environments/environment";
import 'rxjs/Rx';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import {SSO} from './../../sso/sso.constants';
import {CookieService} from 'ngx-cookie-service';
import {RealmType} from '../enums/realm-type.enum';
import {EncryptionService} from "../../sso/encryption.service";

export class HttpService extends Http {
  cookieService: CookieService = new CookieService(document);

  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
    super(backend, defaultOptions);
  }

  /**
   * Performs any type of http request.
   * @param url
   * @param options
   * @returns {Observable<Response>}
   */
  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    return super.request(url, options);
  }

  /**
   * Performs a request with `get` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  get(url: string, options?: RequestOptionsArgs): Observable<any> {
    this.requestInterceptor(options);
    return super.get(this.getFullUrl(url), this.requestOptions(url, options))
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .catch(this.onCatch)
      .finally(() => {
        this.onFinally();
      });
  }

  getLocal(url: string, options?: RequestOptionsArgs): Observable<any> {
    return super.get(url, options);
  }

  /**
   * Performs a request with `post` http method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<>}
   */
  post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
    this.requestInterceptor(options);
    return super.post(this.getFullUrl(url), body, this.requestOptions(url, options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `put` http method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<>}
   */
  put(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
    this.requestInterceptor(options);
    return super.put(this.getFullUrl(url), body, this.requestOptions(url, options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `delete` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  delete(url: string, options?: RequestOptionsArgs): Observable<any> {
    this.requestInterceptor(options);
    return super.delete(this.getFullUrl(url), this.requestOptions(url, options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `delete` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
    this.requestInterceptor(options);
    return super.patch(this.getFullUrl(url), body, this.requestOptions(url, options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }


  /**
   * Request options.
   * @param options
   * @returns {RequestOptionsArgs}
   */
  private requestOptions(url: string, options?: RequestOptionsArgs): RequestOptionsArgs {
    if (options == null) {
      options = new RequestOptions();
    }

    if(!(options && options.headers && options.headers.has('termsAndCondition'))){
    let loginId = SSO.isRemoveObsoleteCookie() ? this.cookieService.get(SSO.INTERNAL_MEMBER_SESSIONID) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);

    if (!loginId) {
      let userInfo = localStorage.getItem("appadmin.UserInfo");
      if (userInfo) {
        localStorage.removeItem("appadmin.UserInfo");
        window.location.reload();
      }
    } else {
      if (SSO.isRemoveObsoleteCookie()) {
        let localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
        if (localMemberSessionId !== loginId) {
          window.location.reload();
        }
      }
    }

  }
    if (options.headers == null) {
      options.headers = new Headers();
    }
    if(!options.headers.has('Content-Type')){
      options.headers.append('Content-Type', 'application/json');
    }
    else{
      options.headers.delete('Content-Type');
    }

    if (url.startsWith(environment.apiUrl) && !url.startsWith(environment.apiUrl + "/payment/")) {
      const uuid = SSO.getnonce();
      options.headers.append('UUID', uuid);

      let accessToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);

      if(options && options.headers && options.headers.has('termsAndCondition')){
        accessToken = " ";
        if (options.headers.has('guestToken')){
          accessToken = JSON.parse(localStorage.getItem('appadmin.guestToken'));
          if(environment.isEnabledOfflineTitanFlow){
            options.headers.set('isOfflineFlow','true');
            }
        }
      }
      if (accessToken) {
        let header = '';
        if (options && options.headers && options.headers.has('guestToken')) {         
          header = 'Bearer ' + accessToken + "&&" + RealmType.TITAN_GUEST;
        }
        else {
          header = 'Bearer ' + accessToken + "&&" + RealmType.TITAN_INTERNAL;
        }
        if (environment.enableAuthorization) {
          options.headers.append('Authorization', this.getAuthorizationHeader(header, uuid));
        }
        if (environment.enableAuthentication) {
          options.headers.append('Authentication', header);
        }
      }
    }

    if( options && options.headers && ( options.headers.has('termsAndCondition') || options.headers.has('guestToken')) ){
      options.headers.delete('termsAndCondition');
      options.headers.delete('guestToken');
    }
    return options;
  }

  private getAuthorizationHeader(token: string, uuid: string): string {
    const data = uuid + '||' + token;
    return EncryptionService.encryptText(data);
  }

  /**
   * Build API url.
   * @param url
   * @returns {string}
   */
  private getFullUrl(url: string): string {
    // return full URL to API here
    //  Remove duplicate slash from request url        
    if(url){
      url = url.replace(/([^:]\/)\/+/g, "$1");
    }
    return url;
  }

  /**
   * Request interceptor.
   */
  private requestInterceptor(options?: RequestOptionsArgs): void {

  }

  /**
   * Response interceptor.
   */
  private responseInterceptor(): void {
  }

  /**
   * Error handler.
   * @param error
   * @param caught
   * @returns {ErrorObservable}
   */
  private onCatch(error: any, caught: Observable<any>): Observable<any> {

    if (error && error.url && error.url.startsWith(environment.ssoApiURL.split("/auth/realm")[0]) || error.url.startsWith(environment.apiUrl)) {
      if (error.status == 401) {
        window.location.href = decodeURIComponent(encodeURIComponent(window.location.href));
      }
    }
    return Observable.throw(error.json());
  }


  /**
   * onSubscribeSuccess
   * @param res
   */
  private onSubscribeSuccess(res: Response): void {
    if (res !== null && res !== undefined) {

    }
  }

  /**
   * onSubscribeError
   * @param error
   */
  private onSubscribeError(error: any): void {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
  }

  /**
   * onFinally
   */
  private onFinally(): void {
    this.responseInterceptor();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/Utils/http.service.ts